import { Avatar, Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress, Divider, Fab, Tab, Tabs, Grid, Tooltip, Typography, TextField, Select, MenuItem, InputAdornment, IconButton, Stack, Modal, Table, TableHead, TableRow, TableCell, TableBody, Paper, FormControl, InputLabel, } from "@mui/material";
import ThreeSixtyIcon from "@mui/icons-material/ThreeSixty";
import React, { useState, useEffect, useContext } from "react";
import clearFilterImage from "../../../src/icons/clearFilter.svg";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport, GridDensitySelector, getGridStringOperators, } from "@mui/x-data-grid";
import searchIcon from "../../icons/searchIcon.svg"
import { TABS, ROLES, DATE_FORMATS } from "../../constants";
import { AuthContext } from "../../components/contextAPI/ContextAPI";
import { Add, AddAPhoto, AddTask, SaveAlt, SaveAltOutlined, SaveAs, ManageSearch, Send, Search } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import UserModal from "../../components/modals/userModal";
import SchoolModal from "../../components/modals/schoolModal";
import DistributorModal from "../../components/modals/distributorModal";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import { height } from "@mui/system";
import axios from "axios";
import { set, toDate } from "date-fns";
import LatLongRequestModal from "../../components/modals/LatLongRequestModal";
const isMobile = window.innerWidth < 900;
const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && `position: relative;`}
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;

const TableContainer = styled.div`
  //   height: calc(
  //     100vh - ${isMobile
    ? "56px - 20px - 82.23px"
    : "128px - 29px - 50.77px"}
  //   );
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;

const DetailsPreviewContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${isMobile && `height: calc(100vh - 56px - 20px);`}
`;

const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const DataGridContainer = styled.div`
  max-width: 100%; /* Add this line to limit the width */
  margin: 0 auto; /* Center the content horizontally */
  height: 100%;
  width: 100%;
  //   border: solid 1px lightGrey;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile && `flex-direction: column;`}
`;

const TabsContainer = styled.div`
  ${isMobile && ` height: calc(100vh - 56px - 20px - 43.77px); `}
`;

const CouponManagement = (props) => {
  const location = useLocation();
  const selectedTabProp1 = location.state?.selectedTabProp;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage1, setCurrentPage1] = useState(1);
  const [paginationModel, setPaginationModel] = useState({ page: currentPage - 1, pageSize: 20, });
  const [paginationModel1, setPaginationModel1] = useState({ page: currentPage1 - 1, pageSize: 20, });
  const [rowCount, setRowCount] = useState();
  const [rowCount1, setRowCount1] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [dateRange1, setDateRange1] = useState(false);
  const [rsms, setRsms] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [asms, setAsms] = useState([]);
  const [rms, setRms] = useState([]);
  const [rm, setRm] = useState("")
  const [rsm, setRsm] = useState("")
  const [asm, setAsm] = useState("")
  const [zh, setZh] = useState("")
  const [zhs, setZhs] = useState([])
  const navigation = useNavigate();
  const [userModal, setUserModal] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [visibleEmployees, setVisibleEmployees] = useState([]);
  const [selectedTab, setSelectedTab] = useState(selectedTabProp1 || TABS.REGISTERED);
  const [filteredDate, setFilteredData] = useState({});
  const [loading, setLoading] = useState(false);
  const [accessModulesData, setAccessModulesData] = useState([]);
  const [modalData, setModalData] = useState([]);
  const [selectedSchoolId, setSelectedSchoolId] = useState(null);
  const [pageSize, setPageSize] = useState(20)
  const { auth, setAuth } = useContext(AuthContext);
  const [schoolModal, setSchoolModal] = useState(false);
  const [distributorModal, setDistributorModal] = useState(false);
  const [editSchool, setEditSchool] = useState(false);
  const [editData, setEditData] = useState();
  const [editData1, setEditData1] = useState();
  const [editDistributor, setEditDistributor] = useState(false);
  const [filter, setFilter] = useState(false);
  const [clusters, setClusters] = useState([])
  const [selectedCluster, setSelectedCluster] = useState("")
  const [searchTerm1, setSearchTerm1] = useState(null);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [search, setSearch] = useState()
  const [searchPincode, setSearchPincode] = useState("")
  const [letLongRequestModal, setLetLongRequestModal] = useState(false);
  const [bulkSchool, setBulkSchool] = useState(false);
  const [bulkDistributor, setBulkDistributor] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openDistributorViewModal, setOpenDistributorViewModal] = useState(false)
  const [modalDistributorViewData, setModalDistributorViewData] = useState([])
  const [selectedDistributorId, setSelectedDistributorId] = useState(null);
  const [showSwapCheck, setShowSwapCheck] = useState(false)
  const [swapValue, setSwpValue] = useState([])
  const [selectedSchools, setSelectedSchools] = useState([]);
  const [newRows, setNewRows] = useState([])
  const [open, setOpen] = useState(false);
  const [rmForSwap, setRmForSwap] = useState("")
  const navigate = useNavigate();
  const [debouncedSearch, setDebouncedSearch] = useState("");

  // ===== Series Wise view modal (Order Coupons tab) =====
  const [seriesModal, setSeriesModal] = useState(false);
  const [selectedSeriesData, setSelectedSeriesData] = useState([]);
  const [selectedPartyName, setSelectedPartyName] = useState("");

  // ===== Send Coupon feature (both tabs) =====
  const [sendingCouponId, setSendingCouponId] = useState(null);
  const [confirmCouponModal, setConfirmCouponModal] = useState(false);
  const [confirmCouponLoading, setConfirmCouponLoading] = useState(false); // remaining-qty fetch loader
  const [confirmCouponRow, setConfirmCouponRow] = useState(null);
  const [confirmCouponType, setConfirmCouponType] = useState(null); // 'order' | 'olympiad'
  const [couponSeriesInput, setCouponSeriesInput] = useState([]); // [{seriesId, seriesName, maxQty, alreadySent, remaining, sendQty}]
  const [couponMomJpqInput, setCouponMomJpqInput] = useState({
    momAvailable: 0, momSent: 0, momMax: 0, momSend: 0,
    jpqAvailable: 0, jpqSent: 0, jpqMax: 0, jpqSend: 0,
  });

  // ===== Per-row "History" button (both tabs) — getOrderCouponHistory / getOlympiadCouponHistory =====
  const [historyModal, setHistoryModal] = useState(false);
  const [historyModalType, setHistoryModalType] = useState(null); // 'order' | 'olympiad'
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyRows, setHistoryRows] = useState([]);
  const [historyPartyName, setHistoryPartyName] = useState("");
  const [historyDetailModal, setHistoryDetailModal] = useState(false);
  const [historyDetailRows, setHistoryDetailRows] = useState([]);
  const [historyDetailTitle, setHistoryDetailTitle] = useState("");

  useEffect(() => {
    if (location.state?.selectedTabProp !== undefined) {
      const tab = location.state.selectedTabProp;
      setSelectedTab(tab);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.key, location.pathname, navigate]);

  const fetchData = async (schoolId) => {
    setLoading(true);
    try {
      const response = await window.Platform.database.getSchoolDataBasedOnId({ schoolId })
      if (response.status == false) {
        setModalData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setModalData([]);
    }
    setLoading(false);
  };

  const fetchData1 = async (distributorID) => {
    setLoading(true);
    try {
      const response = await window.Platform.database.getDistributorByID({ id: distributorID })
      if (response.status == false) {
        setModalDistributorViewData(response?.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setModalDistributorViewData([]);
    }
    setLoading(false);
  };

  const handleOpenModal = (schoolId) => {
    setSelectedSchoolId(schoolId);
    setOpenModal(true);
    fetchData(schoolId);
  };

  const handleOpenDistributorViewModal = (distributorID) => {
    setSelectedDistributorId(distributorID);
    setOpenDistributorViewModal(true);
    fetchData1(distributorID);
  }

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalData([]);
  };

  const handleCloseDistributorViewModal = () => {
    setOpenDistributorViewModal(false);
    setModalDistributorViewData([]);
  }

  const handleOpenSeriesModal = (row) => {
    setSelectedSeriesData(row?.seriesWise || []);
    setSelectedPartyName(row?.schoolName || "");
    setSeriesModal(true);
  };

  const handleCloseSeriesModal = () => {
    setSeriesModal(false);
    setSelectedSeriesData([]);
    setSelectedPartyName("");
  };

  // ===== Send Coupon helpers =====

  // type: 'order' -> uses getOrderCouponHistory (summed per series) to compute remaining
  // type: 'olympiad' -> uses getOlympiadCouponRemaining directly (backend already gives remaining)
  const handleOpenConfirmCoupon = async (row, type) => {
    setConfirmCouponRow(row);
    setConfirmCouponType(type);
    setConfirmCouponModal(true);
    setConfirmCouponLoading(true);

    try {
      if (type === "order") {
        const historyResult = await window.Platform.database.getOrderCouponHistory({
          partyId: row.partyId,
          pageNumber: 0,
          recordPerPage: 200,
        });

        const sentBySeriesId = {};
        if (historyResult?.status) {
          (historyResult?.data || []).forEach((coupon) => {
            (coupon.seriesWise || []).forEach((s) => {
              sentBySeriesId[s.seriesId] = (sentBySeriesId[s.seriesId] || 0) + Number(s.quantity || 0);
            });
          });
        } else if (historyResult?.message) {
          console.log("getOrderCouponHistory (remaining calc) >>>>", historyResult.message);
        }

        const seriesInputs = (row.seriesWise || [])
          .filter((s) => s.quantity > 0)
          .map((s) => {
            const alreadySent = sentBySeriesId[s.seriesId] || 0;
            const remaining = Math.max(0, Number(s.quantity) - alreadySent);
            return {
              seriesId: s.seriesId,
              seriesName: s.seriesName,
              maxQty: s.quantity,
              alreadySent,
              remaining,
              sendQty: remaining, // default: full remaining, user can reduce for partial send
            };
          });
        setCouponSeriesInput(seriesInputs);
      }

      if (type === "olympiad") {
        const remainingResult = await window.Platform.database.getOlympiadCouponRemaining({
          partyId: row.partyId,
        });

        if (remainingResult?.status) {
          const mom = remainingResult?.data?.mom || {};
          const jpq = remainingResult?.data?.jpq || {};
          setCouponMomJpqInput({
            momAvailable: Number(mom.available || 0),
            momSent: Number(mom.alreadySent || 0),
            momMax: Number(mom.remaining || 0),
            momSend: Number(mom.remaining || 0),
            jpqAvailable: Number(jpq.available || 0),
            jpqSent: Number(jpq.alreadySent || 0),
            jpqMax: Number(jpq.remaining || 0),
            jpqSend: Number(jpq.remaining || 0),
          });
        } else {
          window.NotificationUtils.showError(remainingResult?.message || "Remaining count fetch failed");
          setCouponMomJpqInput({
            momAvailable: 0, momSent: 0, momMax: 0, momSend: 0,
            jpqAvailable: 0, jpqSent: 0, jpqMax: 0, jpqSend: 0,
          });
        }
      }
    } catch (error) {
      console.error("Error preparing confirm coupon data:", error);
      window.NotificationUtils.showError("Error fetching remaining coupon data");
    } finally {
      setConfirmCouponLoading(false);
    }
  };

  const handleCloseConfirmCoupon = () => {
    setConfirmCouponModal(false);
    setConfirmCouponRow(null);
    setConfirmCouponType(null);
    setConfirmCouponLoading(false);
    setCouponSeriesInput([]);
    setCouponMomJpqInput({
      momAvailable: 0, momSent: 0, momMax: 0, momSend: 0,
      jpqAvailable: 0, jpqSent: 0, jpqMax: 0, jpqSend: 0,
    });
  };

  const handleSeriesQtyChange = (seriesId, value) => {
    setCouponSeriesInput((prev) =>
      prev.map((s) => {
        if (s.seriesId !== seriesId) return s;
        let v = parseInt(value, 10);
        if (isNaN(v) || v < 0) v = 0;
        if (v > s.remaining) v = s.remaining;
        return { ...s, sendQty: v };
      })
    );
  };

  const handleMomJpqChange = (field, value) => {
    setCouponMomJpqInput((prev) => {
      let v = parseInt(value, 10);
      if (isNaN(v) || v < 0) v = 0;
      const maxField = field === "momSend" ? "momMax" : "jpqMax";
      if (v > prev[maxField]) v = prev[maxField];
      return { ...prev, [field]: v };
    });
  };

  const handleSendCouponForOrder = async () => {
    const row = confirmCouponRow;
    if (!row) return;

    const seriesToSend = couponSeriesInput.filter((s) => s.sendQty > 0);

    if (seriesToSend.length === 0) {
      window.NotificationUtils.showError("Kam se kam ek series me quantity bharo");
      return;
    }

    setSendingCouponId(row.partyId);
    try {
      const payload = {
        partyId: row.partyId,
        schoolName: row.schoolName,
        seriesWise: seriesToSend.map((s) => ({
          seriesId: s.seriesId,
          seriesName: s.seriesName,
          quantity: s.sendQty,
        })),
      };
      const result = await window.Platform.database.sendCouponForOrder(payload);
      if (!result?.status) {
        window.NotificationUtils.showError(result?.message || "Failed to send coupon");
      } else {
        window.NotificationUtils.showSuccess?.(result?.message || "Coupon sent successfully");
      }
    } catch (error) {
      console.error("Send coupon (order) error:", error);
      window.NotificationUtils.showError("Error sending coupon");
    } finally {
      setSendingCouponId(null);
      handleCloseConfirmCoupon();
    }
  };

  const handleSendCouponForOlympiad = async () => {
    const row = confirmCouponRow;
    if (!row) return;

    const { momSend, jpqSend } = couponMomJpqInput;

    if (momSend <= 0 && jpqSend <= 0) {
      window.NotificationUtils.showError("Kam se kam MOM ya JPQ me quantity bharo");
      return;
    }

    setSendingCouponId(row.partyId);
    try {
      const payload = {
        partyId: row.partyId,
        schoolName: row.schoolName,
        momStudents: momSend,
        jpqStudents: jpqSend,
      };
      const result = await window.Platform.database.sendCouponForOlympiad(payload);
      if (!result?.status) {
        window.NotificationUtils.showError(result?.message || "Failed to send coupon");
      } else {
        window.NotificationUtils.showSuccess?.(result?.message || "Coupon sent successfully");
      }
    } catch (error) {
      console.error("Send coupon (olympiad) error:", error);
      window.NotificationUtils.showError("Error sending coupon");
    } finally {
      setSendingCouponId(null);
      handleCloseConfirmCoupon();
    }
  };

  const handleConfirmSendCoupon = () => {
    if (confirmCouponType === "order") {
      handleSendCouponForOrder();
    } else if (confirmCouponType === "olympiad") {
      handleSendCouponForOlympiad();
    }
  };

  // ===== Per-row History (getOrderCouponHistory / getOlympiadCouponHistory scoped to partyId) =====
  const handleOpenHistoryModal = async (row, type) => {
    setHistoryModalType(type);
    setHistoryPartyName(row?.schoolName || row?.partyId || "");
    setHistoryModal(true);
    setHistoryLoading(true);
    try {
      const apiName = type === "order" ? "getOrderCouponHistory" : "getOlympiadCouponHistory";
      const result = await window.Platform.database[apiName]({
        partyId: row.partyId,
        pageNumber: 0,
        recordPerPage: 50,
      });
      if (!result?.status) {
        window.NotificationUtils.showError(result?.message || "History fetch failed");
        setHistoryRows([]);
      } else {
        setHistoryRows(result?.data || []);
      }
    } catch (error) {
      console.error("Error fetching coupon history:", error);
      window.NotificationUtils.showError("Error fetching coupon history");
      setHistoryRows([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleCloseHistoryModal = () => {
    setHistoryModal(false);
    setHistoryModalType(null);
    setHistoryRows([]);
    setHistoryPartyName("");
  };

  const handleOpenHistoryDetail = (row) => {
    const breakdown = historyModalType === "order" ? row.seriesWise : row.olympiadTypeWise;
    setHistoryDetailRows(breakdown || []);
    setHistoryDetailTitle(row?.schoolName || row?.partyId || "");
    setHistoryDetailModal(true);
  };

  const handleCloseHistoryDetail = () => {
    setHistoryDetailModal(false);
    setHistoryDetailRows([]);
    setHistoryDetailTitle("");
  };

  useEffect(() => {
    setVisibleEmployees([]);
    setHasSearched(false);
    setRsm("");
    setZh("");
    setAsm("");
    setRm("");
    setSearch("");
    setSearchPincode("");
    setSelectedCluster("");
    setSelectedSchools([]);
    setFilter(false);
  }, [selectedTab])

  useEffect(() => {
    setShowSwapCheck(false);
    if (!filter) {
      if (hasSearched) {
        fetchEmployees();
      }
    }
  }, [paginationModel.page, paginationModel1.page, paginationModel.pageSize, paginationModel1.pageSize]);

  useEffect(() => {
    fetchSessions();
    fetchAccessModules();
    if (userData?.role.toLowerCase().includes('admin')) {
      getAllUsers()
    }
    if (userData?.role == 'zh') {
      getUsers('zh', userData?.id)
    }
    if (userData?.role == 'rsm') {
      getUsers('rsm', userData?.id)
    }
    if (userData?.role == 'asm') {
      getUsers('asm', userData?.id)
    }
  }, [])

  async function getAllUsers() {
    let results = await window.Platform.database.fetchEmployees()
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      setLoading(false);
      return;
    }
    else {
      setAllUsers(results?.data)
      setZhs(results?.data?.filter((ele) => ele.role.toLowerCase() == 'zh'))
      setRsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'rsm'))
      setRms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'se'))
      setAsms(results?.data?.filter((ele) => ele.role.toLowerCase() == 'asm'))
      setLoading(false);
    }
  }


  async function getUsers(role, id) {
    if (id != "") {
      let results = await window.Platform.database.getUsersBasedOnManager({ userId: id })
      if (role == 'rsm') {
        setZhs(results?.data?.filter((ele) => ele.role == "zh"))
        setAsms(results?.data?.filter((ele) => ele.role == 'asm'))
        setRms(results?.data1)
      }
      if (role == 'zh') {
        setAsms(results?.data?.filter((ele) => ele.role == 'asm'))
        setRms(results?.data1)
      }
      if (role == 'asm') {
        setRms(results?.data)
      }
    } else {
      if (role == 'zh') {
        setAsm("")
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
      }
      if (role == 'rsm') {
        setRm("")
        setAsm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
        setAsms(allUsers?.filter((ele) => ele.role == 'asm'))
        setZhs(allUsers?.filter((ele) => ele.role == "zh"))
      }
      if (role == 'asm') {
        setRm("")
        setRms(allUsers?.filter((ele) => ele.role == 'se'))
      }
    }

  }
  let contextState = { ...auth };

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true, // Use 12-hour clock
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString(
      "en-US",
      options
    );

    return formattedDate;
  };

  const formatTime12 = (timeStr) => {
    if (!timeStr) return "N/A";
    const [hour, minute] = timeStr.split(":");
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${minute} ${ampm}`;
  };

  const handleCheckboxChange = (e, schoolId) => {
    const isChecked = e.target.checked;
    if (e.target.checked) {
      setSelectedSchools((prev) => [...prev, schoolId]);
    } else {
      setSelectedSchools((prev) => prev.filter((id) => id !== schoolId));
    }
  };
  const schoolColumns = () => {
    const stringOperators = getGridStringOperators().filter((op) =>
      ["contains"].includes(op.value)
    );

    let result = [
      {
        field: "schoolId12",
        headerName: "School Id",
        width: 200,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.partyId;
        },
        renderCell: (params) => {
          const name = params.row?.partyId;
          return (
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }} >
              <Tooltip title={name || "N/A"}>
                <Typography
                  variant="inherit"
                  sx={{ color: "black", fontSize: "11px", fontWeight: "500", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100px", }} >
                  {name}
                </Typography>
              </Tooltip>
            </div>
          );
        },
      },
      {
        field: "schoolName",
        headerName: "Name",
        minWidth: 500,
        valueGetter: (params) => {
          let name = params.row?.schoolName;
          return name?.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row?.schoolName?.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ") || "N/A";

          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "totalOrders",
        headerName: "Total Orders",
        minWidth: 130,
        sortable: false,
        renderCell: (params) => {
          const value = params.row.totalOrders ?? "N/A";
          return (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>{value}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "totalQuantity",
        headerName: "Total Quantity",
        minWidth: 140,
        sortable: false,
        renderCell: (params) => {
          const value = params.row.totalQuantity ?? "N/A";
          return (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>{value}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "totalAmount",
        headerName: "Total Amount",
        minWidth: 140,
        sortable: false,
        renderCell: (params) => {
          const value = params.row.totalAmount ?? "N/A";
          return (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                {typeof value === "number" ? value.toLocaleString("en-IN") : value}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "seriesWiseView",
        headerName: "Series Wise",
        minWidth: 130,
        sortable: false,
        renderCell: (params) => {
          return (
            <Button
              variant="outlined"
              size="small"
              onClick={() => handleOpenSeriesModal(params.row)}
              sx={{ minWidth: "80px", fontSize: "11px" }}
            >
              View
            </Button>
          );
        },
      },
      {
        field: "sendCouponOrder",
        headerName: "Send Coupon",
        minWidth: 140,
        sortable: false,
        renderCell: (params) => {
          const isSending = sendingCouponId === params.row.partyId;
          return (
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={isSending || !params.row.totalQuantity}
              onClick={() => handleOpenConfirmCoupon(params.row, "order")}
              sx={{ minWidth: "90px", fontSize: "11px" }}
            >
              {isSending ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : "Send Coupon"}
            </Button>
          );
        },
      },
      {
        field: "orderCouponHistory",
        headerName: "History",
        minWidth: 110,
        sortable: false,
        renderCell: (params) => {
          return (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => handleOpenHistoryModal(params.row, "order")}
              sx={{ minWidth: "80px", fontSize: "11px" }}
            >
              History
            </Button>
          );
        },
      },
    ].filter(Boolean);
    return result;
  };

  const distributorColumn = () => {
    const stringOperators = getGridStringOperators().filter((op) =>
      ["contains"].includes(op.value)
    );

    let result = [
      {
        field: "dist12",
        headerName: "School Id",
        width: 200,
        filterable: false,
        sortable: false,
        valueGetter: (params) => {
          return params.row.partyId;
        },
        renderCell: (params) => {
          const name = params.row.partyId;
          return (
            <div
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", }}>
              <Tooltip title={name || "N/A"}>
                <Typography
                  variant="inherit"
                  sx={{ color: "black", fontSize: "11px", fontWeight: "500", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100px", }}  >
                  {name}
                </Typography>
              </Tooltip>
            </div>
          );
        },
      },
      {
        field: "PartyName",
        headerName: "Party Name",
        minWidth: 350,
        valueGetter: (params) => {
          let name = params.row.schoolName;
          return name?.split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(" ");
        },
        sortable: false,
        filterOperators: stringOperators,
        renderCell: (params) => {
          let name = params.row.schoolName?.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ") || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "totalRegistrations",
        headerName: "Total Registration",
        sortable: false,
        width: 160,
        renderCell: (params) => {
          const value = params.row.totalRegistrations || "N/A";
          return (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                {value}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "totalStudents",
        headerName: "Total Students",
        sortable: false,
        width: 150,
        renderCell: (params) => {
          const value = params.row.totalStudents || "N/A";
          return (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                {value}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "totalStudyMaterial",
        headerName: "Total Study Material",
        sortable: false,
        width: 170,
        renderCell: (params) => {
          const value = params.row.totalStudyMaterial || "N/A";
          return (
            <Tooltip title={value}>
              <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                {value}
              </Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "sendCouponOlympiad",
        headerName: "Send Coupon",
        sortable: false,
        width: 150,
        renderCell: (params) => {
          const isSending = sendingCouponId === params.row.partyId;
          return (
            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={isSending || !params.row.totalStudents}
              onClick={() => handleOpenConfirmCoupon(params.row, "olympiad")}
              sx={{ minWidth: "90px", fontSize: "11px" }}
            >
              {isSending ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : "Send Coupon"}
            </Button>
          );
        },
      },
      {
        field: "olympiadCouponHistory",
        headerName: "History",
        sortable: false,
        width: 130,
        renderCell: (params) => {
          return (
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => handleOpenHistoryModal(params.row, "olympiad")}
              sx={{ minWidth: "80px", fontSize: "11px" }}
            >
              History
            </Button>
          );
        },
      },
    ];
    return result;
  };

  const handleTabChange = async (value, keepSelected = false) => {
    setVisibleEmployees([]);
    if (!keepSelected) {
    }
    setFilter(false);
    setEndDate(null);
    setDateRange1(false);
    setSelectedTab(value);
  };

  const fetchAccessModules = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        userId: userData?.id,
        moduleId: "rMAeIXw9kl"
      }
      let results = await window.Platform.database.fetchAccessModules(data);
      if (results?.status) {
        window.NotificationUtils.showError(results?.message || "Something went wrong");
        setLoading(false);
        return;
      }
      else {
        const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
        setAccessModulesData(jsonArrayWithId);
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoading(false)
    }
  }

  const fetchSessions = async () => {
    try {
      setLoading(true);
      const response = await window.Platform.database.getAllSessions();
      if (response?.status) {
        const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
        setFilteredData(filterdData1[0])
      }
      else {
        window.NotificationUtils.showError("Something Went Wrong in session")
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      window.NotificationUtils.showError("Failed to load sessions");
    } finally {
      setLoading(false);
    }
  };


  const fetchEmployees = async () => {
    setLoading(true);
    try {
      setVisibleEmployees([]);
      let results;
      if (selectedTab === 1) {
        results = await window.Platform.database.getTotalStudentByPartyId({
          //  ownerId: rm,
          //     asm: userData?.role === 'asm' ? userData?.id : asm,
          //     rsm: userData?.role === 'rsm' ? userData?.id : rsm,
          //     fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
          //     toDate: endDate !== '' ? endDate : filteredDate?.endDate,
          //     pageNumber: paginationModel.page,
          //     recordPerPage: paginationModel.pageSize,
          //     search: search,
          //     olympiadDate: olympiadDate,
          ownerId: rm,
          partyId: "",
          search: "",
          rsm: userData?.role == 'rsm' ? userData?.id : rsm,
          asm: userData?.role == 'asm' ? userData?.id : asm,
          // fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
          // toDate: endDate !== '' ? endDate : filteredDate?.endDate,
          fromDate: filteredDate?.startDate,
          toDate: filteredDate?.endDate,
          pageNumber: paginationModel1.page,
          recordPerPage: paginationModel1.pageSize,
        });
        setRowCount1(results?.data1);
      } else {
        results = await window.Platform.database.getPartywiseSeriesQuantity({
          ownerId: rm,
          asm: userData?.role === 'asm' ? userData?.id : asm,
          rsm: userData?.role === 'rsm' ? userData?.id : rsm,
          // fromDate: startDate !== '' ? startDate : filteredDate?.startDate,
          // toDate: endDate !== '' ? endDate : filteredDate?.endDate,
          fromDate: filteredDate?.startDate,
          toDate: filteredDate?.endDate,
          pageNumber: paginationModel.page,
          recordPerPage: paginationModel.pageSize,
        });
        setRowCount(results?.data1);
        setNewRows(results?.data)
      }

      const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, id: index + 1 }));
      setVisibleEmployees(jsonArrayWithId);
      setLoading(false);
      if (!results.status) {
        setLoading(false);
        window.NotificationUtils.showError(results.message);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  };

  const clearFilter = async () => {
    setHasSearched(false);
    setSearch("");
    setRsm("");
    setAsm("");
    setRm("");
    setZh("");
    setRsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'rsm'));
    setRms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'se'));
    setAsms(allUsers?.filter((ele) => ele.role.toLowerCase() === 'asm'));
    setSelectedCluster("");
    setSearchPincode("");
    setLoading(true);
    setVisibleEmployees([]);
    setRowCount(0);
    setRowCount1(0);
    setNewRows([]);
    setShowSwapCheck(false);
    setFilter(false);
    setPaginationModel({ page: 0, pageSize: 20 });
    setLoading(false);
  };

  const scrollToPreview = () => {
    window.scrollTo(
      0,
      document.getElementById("detailsPreviewContainer").getBoundingClientRect()
        .top
    );
  };

  const renderTabContent = () => {
    if (selectedTab === 0) {
      return (<>
        <div className="d-flex justify-content-end align-items-center  py-2">
          <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { setHasSearched(true); setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
            sx={{ width: 90, fontSize: 13, fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
            ))}
          </Select>
        </div>
        <DataGridContainer
          style={{ height: !visibleEmployees.length ? "200px" : "auto" }}
        >
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={visibleEmployees || []}
            columns={schoolColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            disableSelectionOnClick
            disableRowSelectionOnClick
            onRowClick={(rowParams, event) => {
              setUserModal(rowParams.row);
            }}
            rowHeight={60}
            pageSizeOptions={[10]}
            rowCount={rowCount}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
          />
        </DataGridContainer>
        <Dialog open={seriesModal} onClose={handleCloseSeriesModal} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontSize: "16px", fontWeight: 600 }}>
            Series Wise Quantity — {selectedPartyName || "N/A"}
          </DialogTitle>
          <DialogContent dividers>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>Series Name</TableCell>
                  <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedSeriesData
                  ?.filter((s) => s.quantity > 0)
                  ?.sort((a, b) => b.quantity - a.quantity)
                  ?.map((s) => (
                    <TableRow key={s.seriesId}>
                      <TableCell sx={{ fontSize: "12.5px", textTransform: "capitalize" }}>
                        {s.seriesName}
                      </TableCell>
                      <TableCell sx={{ fontSize: "12.5px" }} align="right">
                        {s.quantity}
                      </TableCell>
                    </TableRow>
                  ))}
                {(!selectedSeriesData || selectedSeriesData.every((s) => s.quantity === 0)) && (
                  <TableRow>
                    <TableCell colSpan={2} align="center" sx={{ fontSize: "12.5px", color: "gray" }}>
                      No series data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseSeriesModal} variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
      );
    } else if (selectedTab === 1) {
      return (
        <>
          <div className="d-flex justify-content-end align-items-center  py-2">
            <Typography variant="body1" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
            <Select value={paginationModel1.pageSize} variant="outlined" size="small" onChange={(e) => { setPaginationModel1({ ...paginationModel1, pageSize: e.target.value }); setHasSearched(true) }} sx={{ width: 90, fontSize: 14, fontWeight: "500" }} >
              {[10, 20, 30, 50, 100].map((role) => (
                <MenuItem key={role} value={role} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role}</MenuItem>
              ))}
            </Select>
          </div>
          <DataGridContainer style={{ height: !visibleEmployees?.length ? "200px" : "auto" }}>
            <DataGrid
              className="payrollGrid"
              density="compact"
              rows={visibleEmployees || []}
              columns={distributorColumn()}
              sx={{ color: "black", fontSize: "13px", fontWeight: "600" }}
              disableSelectionOnClick
              disableRowSelectionOnClick
              pageSizeOptions={[10]}
              onRowClick={(rowParams, event) => {
                setUserModal(rowParams.row);
              }}
              rowHeight={60}
              filterMode="server"
              rowCount={rowCount1}
              paginationModel={paginationModel1}
              paginationMode="server"
              onPaginationModelChange={setPaginationModel1}
            />
          </DataGridContainer>
        </>
      );
    }
  };

  const getClusterInPicklist = async () => {
    setLoading(true);
    try {
      let results = await window.Platform.database.getClusterInPicklist();
      const jsonArrayWithId = results?.data?.map((obj) => ({ ...obj, dbId: obj.id }));
      setClusters(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      console.error("ERRORCHECK", error);
      setLoading(false);
    }
  };

  const exportPartywiseSeriesQuantity = async () => {
    setLoading(true);
    try {
      let data = {
        pageNumber: paginationModel.page,
        filter: search,
        pincode: searchPincode,
        recordPerPage: paginationModel.pageSize,
        cluster: selectedCluster,
        ownerId: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm,
      };
      let result = await window.Platform.database.exportData("/order/exportPartywiseSeriesQuantity", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "orderCoupons.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  const exportOlympiadPartywiseStudent = async () => {
    setLoading(true);
    try {
      let data = {
        filter: search,
        cluster: selectedCluster,
        ownerId: rm,
        rsm: userData?.role == 'rsm' ? userData?.id : rsm,
        asm: userData?.role == 'asm' ? userData?.id : asm
      };
      let result = await window.Platform.database.exportData("/olympiad/exportOlympiadPartywiseStudent", data)
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "olympiadCoupons.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          <Box sx={{ mt: 1, width: "100%" }}>
            <Paper elevation={3}
              sx={{ p: 2, mb: 2, width: '100%', mx: 'auto', backgroundColor: "#ebf0fa" }}>
              <div className="container-fluid" style={{ width: "100%" }}>
                <div className="row">
                  {userData?.role.includes('admin') && <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select HO</InputLabel>
                      <Select value={rsm} label="Select HO" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} size="small" onChange={(e) => { setRsm(e.target.value); getUsers('rsm', e.target.value); setAsm(""); setRm(""); setZh(""); }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rsms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  {userData?.role != 'asm' && <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select ARM</InputLabel>
                      <Select value={asm} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} label="Select ARM" size="small" onChange={(e) => { setAsm(e.target.value); getUsers('asm', e.target.value); setRm("") }} >
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {asms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>}
                  <div className="col-md-3">
                    <FormControl size="small" fullWidth>
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select RM:</InputLabel>
                      <Select value={rm} label="Select RM" size="small" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }} onChange={(e) => { setRm(e.target.value) }}>
                        <MenuItem value="" sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>All</MenuItem>
                        {rms.map((role) => (
                          <MenuItem key={role} value={role.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{role.name} - {role.username}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    <Button variant="contained" color="primary" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} fullWidth sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { setHasSearched(true); fetchEmployees() }}>
                      Find
                    </Button>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-3 mt-2">
                    {selectedTab == 0 ? <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" fullWidth sx={{ borderRadius: "10px" }} onClick={() => { clearFilter() }}>Clear Filters</Button> : <Button variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"21"} width={"21"} />} color="secondary" fullWidth sx={{ borderRadius: "10px" }} onClick={() => { clearFilter() }}>Clear Filters</Button>}
                  </div>
                  {accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" && <div className="col-md-3 mt-2">
                    {selectedTab == 0 ? <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { exportPartywiseSeriesQuantity() }}>Download</Button> : <Button variant="contained" color="success" startIcon={<FileDownloadIcon />} fullWidth sx={{ borderRadius: "10px" }} onClick={() => { exportOlympiadPartywiseStudent() }}>Download</Button>}
                  </div>}
                </div>
              </div>
            </Paper>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, px: 2, py: 1, background: "#e8f5e9", border: "1px solid #a5d6a7", borderLeft: "4px solid #2e7d32", borderRadius: "8px", boxShadow: "0 2px 6px rgba(0,0,0,0.08)", width: "fit-content", }}>
                <Typography
                  sx={{ fontSize: "13px", fontWeight: 600, color: "#1b5e20", letterSpacing: "0.3px", }}>
                  Total Entries:
                </Typography>
                <Typography
                  sx={{ fontSize: "15px", fontWeight: 700, color: "#2e7d32", background: "#fff", px: 1.2, py: 0.2, borderRadius: "6px", border: "1px solid #a5d6a7", minWidth: "28px", textAlign: "center", }}>
                  {visibleEmployees?.length > 0 ? selectedTab == 0 ? rowCount : rowCount1 : 0 || 0}
                </Typography>
              </Box>
            </Box>
          </Box>
        </HeaderContainer>
        <TableContainer>
          <TabsContainer>
            <StyledTabs variant="fullWidth" value={selectedTab} onChange={(event, value) => handleTabChange(value)} indicatorColor="none" textColor="primary">
              <Tab label="Order Coupons" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />
              {<Tab label="Olympiad Coupons" sx={{ fontSize: "15px", color: "#000", fontWeight: "600", backgroundColor: selectedTab == 1 ? "#fff" : "#e6e3e3de " }} />}
            </StyledTabs>
            {loading && <OpaqueLoading />}
            {renderTabContent()}
          </TabsContainer>
        </TableContainer>

        {/* ===== Send Coupon — Confirm & editable quantity dialog (shared by both tabs), with live Remaining ===== */}
        <Dialog open={confirmCouponModal} onClose={handleCloseConfirmCoupon} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontSize: "16px", fontWeight: 600 }}>
            Send Coupon — {confirmCouponRow?.schoolName || "N/A"}
          </DialogTitle>
          <DialogContent dividers>
            <Typography sx={{ fontSize: "12.5px", color: "gray", mb: 2 }}>
            </Typography>

            {confirmCouponLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ padding: "24px 0" }}>
                <CircularProgress size={28} />
              </div>
            ) : (
              <>
                {confirmCouponType === "order" && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF" }}>Series</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Available</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Already Sent</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Remaining</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Send Qty</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {couponSeriesInput.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ fontSize: "12.5px", color: "gray" }}>
                            No series with quantity available
                          </TableCell>
                        </TableRow>
                      )}
                      {couponSeriesInput.map((s) => (
                        <TableRow key={s.seriesId}>
                          <TableCell sx={{ fontSize: "12.5px", textTransform: "capitalize" }}>
                            {s.seriesName}
                          </TableCell>
                          <TableCell sx={{ fontSize: "12.5px" }} align="right">
                            {s.maxQty}
                          </TableCell>
                          <TableCell sx={{ fontSize: "12.5px" }} align="right">
                            {s.alreadySent}
                          </TableCell>
                          <TableCell sx={{ fontSize: "12.5px", fontWeight: 600 }} align="right">
                            {s.remaining}
                          </TableCell>
                          <TableCell align="right">
                            <TextField
                              type="number"
                              size="small"
                              value={s.sendQty}
                              onChange={(e) => handleSeriesQtyChange(s.seriesId, e.target.value)}
                              inputProps={{ min: 0, max: s.remaining, style: { fontSize: "12.5px", padding: "4px 8px", width: "70px", textAlign: "right" } }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}

                {confirmCouponType === "olympiad" && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Available</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Already Sent</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Remaining</TableCell>
                        <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Send Qty</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontSize: "12.5px" }}>MOM Students</TableCell>
                        <TableCell sx={{ fontSize: "12.5px" }} align="right">{couponMomJpqInput.momAvailable}</TableCell>
                        <TableCell sx={{ fontSize: "12.5px" }} align="right">{couponMomJpqInput.momSent}</TableCell>
                        <TableCell sx={{ fontSize: "12.5px", fontWeight: 600 }} align="right">{couponMomJpqInput.momMax}</TableCell>
                        <TableCell align="right">
                          <TextField
                            type="number"
                            size="small"
                            value={couponMomJpqInput.momSend}
                            onChange={(e) => handleMomJpqChange("momSend", e.target.value)}
                            inputProps={{ min: 0, max: couponMomJpqInput.momMax, style: { fontSize: "12.5px", padding: "4px 8px", width: "70px", textAlign: "right" } }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: "12.5px" }}>JPQ Students</TableCell>
                        <TableCell sx={{ fontSize: "12.5px" }} align="right">{couponMomJpqInput.jpqAvailable}</TableCell>
                        <TableCell sx={{ fontSize: "12.5px" }} align="right">{couponMomJpqInput.jpqSent}</TableCell>
                        <TableCell sx={{ fontSize: "12.5px", fontWeight: 600 }} align="right">{couponMomJpqInput.jpqMax}</TableCell>
                        <TableCell align="right">
                          <TextField
                            type="number"
                            size="small"
                            value={couponMomJpqInput.jpqSend}
                            onChange={(e) => handleMomJpqChange("jpqSend", e.target.value)}
                            inputProps={{ min: 0, max: couponMomJpqInput.jpqMax, style: { fontSize: "12.5px", padding: "4px 8px", width: "70px", textAlign: "right" } }}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirmCoupon} variant="outlined">
              Cancel
            </Button>
            <Button
              onClick={handleConfirmSendCoupon}
              variant="contained"
              color="primary"
              disabled={confirmCouponLoading || sendingCouponId === confirmCouponRow?.partyId}
            >
              {sendingCouponId === confirmCouponRow?.partyId ? "Sending..." : "Confirm & Send"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* ===== Per-row History — getOrderCouponHistory / getOlympiadCouponHistory scoped to one partyId ===== */}
        <Dialog open={historyModal} onClose={handleCloseHistoryModal} maxWidth="md" fullWidth>
          <DialogTitle sx={{ fontSize: "16px", fontWeight: 600 }}>
            Coupon History — {historyPartyName || "N/A"}
          </DialogTitle>
          <DialogContent dividers>
            {historyLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ padding: "24px 0" }}>
                <CircularProgress size={28} />
              </div>
            ) : (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>Coupon Id</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">
                      {historyModalType === "order" ? "Total Quantity" : "Total Students"}
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>Sent By</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>Sent At</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>Remark</TableCell>
                    <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Breakdown</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historyRows.map((row) => (
                    <TableRow key={row.couponId}>
                      <TableCell sx={{ fontSize: "12.5px" }}>{row.couponId}</TableCell>
                      <TableCell sx={{ fontSize: "12.5px" }} align="right">
                        {historyModalType === "order" ? row.totalQuantity : row.totalStudents}
                      </TableCell>
                      <TableCell sx={{ fontSize: "12.5px" }}>{row.ownerName || "N/A"}</TableCell>
                      <TableCell sx={{ fontSize: "12.5px" }}>{row.createdAt ? formatTimeStamp(row.createdAt) : "N/A"}</TableCell>
                      <TableCell sx={{ fontSize: "12.5px" }}>{row.remark || "-"}</TableCell>
                      <TableCell align="right">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => handleOpenHistoryDetail(row)}
                          sx={{ minWidth: "70px", fontSize: "11px" }}
                        >
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {historyRows.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ fontSize: "12.5px", color: "gray" }}>
                        No coupon sent yet
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseHistoryModal} variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* ===== History row breakdown (series / MOM-JPQ) ===== */}
        <Dialog open={historyDetailModal} onClose={handleCloseHistoryDetail} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontSize: "16px", fontWeight: 600 }}>
            Breakdown — {historyDetailTitle || "N/A"}
          </DialogTitle>
          <DialogContent dividers>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }}>
                    {historyModalType === "order" ? "Series Name" : "Type"}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, fontSize: "13px", color: "#FFF"  }} align="right">Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {historyDetailRows.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell sx={{ fontSize: "12.5px", textTransform: "capitalize" }}>
                      {historyModalType === "order" ? r.seriesName : r.olympiadTypeName}
                    </TableCell>
                    <TableCell sx={{ fontSize: "12.5px" }} align="right">
                      {historyModalType === "order" ? r.quantity : r.studentsSent}
                    </TableCell>
                  </TableRow>
                ))}
                {historyDetailRows.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={2} align="center" sx={{ fontSize: "12.5px", color: "gray" }}>
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseHistoryDetail} variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </StaffEditorPageContainer>
    </>
  );
};
export default CouponManagement;